import { ColumnDefinition } from '../../../../../../generic/universal-table/types/column.types'
import { CustomerUiRow } from '../types/customerTable.types'

export const customerTableColumns: ColumnDefinition<CustomerUiRow>[] = [
  {
    key: 'CustomerID',
    title: 'מזהה',
    dataType: 'number',
    width: '70px',
    sortable: true,
    editable: false,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'CustomerName',
    title: 'שם לקוח',
    dataType: 'string',
    width: '180px',
    sortable: true,
    editable: true,
    visible: true,
    required: true,
    cellRendererType: 'text',
  },
  {
    key: 'ClientID',
    title: 'לקוח',
    dataType: 'number',
    width: '160px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
    // labelResolver is injected in CustomerTableModule.tsx
  },
  {
    key: 'ResellerID',
    title: 'משווק',
    dataType: 'number',
    width: '160px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
    // labelResolver is injected in CustomerTableModule.tsx
  },
  {
    key: 'MarketingAreaID',
    title: 'אזור שיווק',
    dataType: 'number',
    width: '160px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
    // labelResolver is injected in CustomerTableModule.tsx
  },
  {
    key: 'Phone',
    title: 'טלפון',
    dataType: 'string',
    width: '130px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'CustomerType',
    title: 'סוג לקוח',
    dataType: 'string',
    width: '120px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'WarehouseID',
    title: 'מחסן',
    dataType: 'number',
    width: '90px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Company',
    title: 'חברה',
    dataType: 'number',
    width: '90px',
    sortable: true,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'CustomerGroupID',
    title: 'קבוצת לקוח',
    dataType: 'number',
    width: '110px',
    sortable: true,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'DeliveryCode',
    title: 'קוד משלוח',
    dataType: 'number',
    width: '110px',
    sortable: true,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'LandTransp',
    title: 'הובלה יבשתית',
    dataType: 'number',
    width: '110px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Cosher',
    title: 'כשרות',
    dataType: 'number',
    width: '90px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Meher',
    title: 'מהדרין',
    dataType: 'number',
    width: '90px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'NeedGrowthGroup',
    title: 'קבוצת גידול',
    dataType: 'number',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'OneMany',
    title: 'יחיד/רבים',
    dataType: 'number',
    width: '90px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'PickupGroup',
    title: 'קבוצת איסוף',
    dataType: 'number',
    width: '110px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'PickupWarehouse',
    title: 'מחסן איסוף',
    dataType: 'number',
    width: '110px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'PriceListID',
    title: 'מחירון',
    dataType: 'number',
    width: '90px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'RampId',
    title: 'רמפה',
    dataType: 'number',
    width: '80px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'TransferPallets2Warehouse',
    title: 'העברת משטחים למחסן',
    dataType: 'number',
    width: '140px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'TrasportationMethod',
    title: 'שיטת הובלה',
    dataType: 'number',
    width: '110px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Color',
    title: 'צבע',
    dataType: 'string',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'ShippAddress',
    title: 'כתובת משלוח',
    dataType: 'string',
    width: '180px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Active',
    title: 'פעיל',
    dataType: 'boolean',
    width: '70px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'checkbox',
    align: 'center',
  },
  {
    key: 'Blocked',
    title: 'חסום',
    dataType: 'boolean',
    width: '70px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'checkbox',
    align: 'center',
  },
  {
    key: 'AllowBouncing',
    title: 'מאפשר קפיצה',
    dataType: 'boolean',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'DeliveryPrice',
    title: 'מחיר משלוח',
    dataType: 'boolean',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Friday',
    title: 'שישי',
    dataType: 'boolean',
    width: '70px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Monday',
    title: 'שני',
    dataType: 'boolean',
    width: '70px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'PackUsage',
    title: 'שימוש באריזה',
    dataType: 'boolean',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'PriceList',
    title: 'מחירון פעיל',
    dataType: 'boolean',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Saturday',
    title: 'שבת',
    dataType: 'boolean',
    width: '70px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'SavedPriceToOrderProduct',
    title: 'שמירת מחיר להזמנה',
    dataType: 'boolean',
    width: '120px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'TransferResetCustomerID',
    title: 'איפוס לקוח בהעברה',
    dataType: 'boolean',
    width: '130px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Tuesday',
    title: 'שלישי',
    dataType: 'boolean',
    width: '70px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Wednesday',
    title: 'רביעי',
    dataType: 'boolean',
    width: '70px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'has_levies',
    title: 'היטלים',
    dataType: 'number',
    width: '80px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
]
